import { render, staticRenderFns } from "./MedicoesTemplateModal.vue?vue&type=template&id=2fa0b34a&scoped=true"
import script from "./MedicoesTemplateModal.vue?vue&type=script&lang=js"
export * from "./MedicoesTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./MedicoesTemplateModal.vue?vue&type=style&index=0&id=2fa0b34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0b34a",
  null
  
)

export default component.exports